import React from 'react';
import {duckify, currentUser} from "utils/duckify";

const userExists = (user) => !!user;
const userIsAdmin = (user) => userExists(user) && user.is_admin;
const userIsSuperAdmin = (user) => userExists(user) && user.is_super_admin;

/**
 * Wrapper HOC that only renders the wrapped component if the current user exists and meets the specified criteria.
 *
 * @param shouldShowToUser  function to check if the current user should see the component or not.
 *                          By default, shows to any logged in user
 */
export const requiresUser = (shouldShowToUser = (user) => true) => (WrappedComponent) => {
  const mapCurrentUserToProps = () => ({currentUser});

  const showWrappedComponent = (props) => {
    if (props.duckMeta.currentUser.ready && shouldShowToUser(props.currentUser)) {
      return <WrappedComponent {...props}/>;
    }
    else{
      return <React.Fragment/>;
    }
  };

  return duckify(mapCurrentUserToProps)(showWrappedComponent);
};

/**
 * Wrapper HOC that only renders a component if the user is a superadmin
 */
export const requiresSuperAdmin = (WrappedComponent) => requiresUser(userIsSuperAdmin)(WrappedComponent);

/**
 * Wrapper HOC that only renders a component if the user is an admin
 */
export const requiresAdmin = (WrappedComponent) => requiresUser(userIsAdmin)(WrappedComponent);
